import React from 'react';
import { useLanguage } from '../data/i18n';
export function LanguageToggle({
  className = ''
}: {
  className?: string;
}) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div className={`inline-flex items-center border border-white/30 ${className}`} role="group" aria-label={t.langLabel} data-id="element-174" data-mp="2y6v4lhvg2u6l">
      {(['es', 'en'] as const).map(code => {
      const active = lang === code;
      return <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={active} className={`px-3 py-2 font-sans text-[10px] uppercase tracking-[0.25em] transition-colors ${active ? 'bg-white text-black' : 'text-ash hover:text-white'}`} data-id="element-175" data-mp="25ipfkixcyj0y">
            {code}
          </button>;
    })}
    </div>;
}